// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  RedirectSiteUrlWhenLock: 'https://www.google.com',
  msalConfig: {
      auth: {
          clientId: "f2f1e4cd-ab7d-4b67-8bd7-18d8368e1e36",
      }
  },
  apiConfig: {
      scopes: ['https://nhcportal.onmicrosoft.com/nhcportalapi/api/customer.readwrite'],
      uri: "https://nhcportalapi.azurewebsites.net"
  },
  b2cPolicies: {
      names: {
          signUpSignIn: 'B2C_1_NHC_signIn', //replace these names properly the way you created in azure portal
          editProfile: 'B2C_1_NHC_Send_ResetPassword',
          resetPassword: 'B2C_1_NHC_Send_ResetPassword',
        },
      authorities: {
          signUpSignIn: {
            authority:
              'https://nhcportal.b2clogin.com/nhcportal.onmicrosoft.com/B2C_1_NHC_signIn',
          },
          editProfile: {
            authority:
              'https://nhcportal.b2clogin.com/nhcportal.onmicrosoft.com/B2C_1_NHC_Send_ResetPassword',
          },
          resetPassword: {
            authority:
              'https://nhcportal.b2clogin.com/nhcportal.onmicrosoft.com/B2C_1_NHC_Send_ResetPassword',
          }
        },
        authorityDomain: 'nhcportal.b2clogin.com'
  },
  passportVerification: {
      clientId: '88suuW4BVawo0JSo21EuGsScW',
      redirectUri: 'https://portal.nhc.no/verify-passport',
      anonymousRedirectUri: 'https://portal.nhc.no/contact-verify-passport',
      authUrl: 'https://app.verified.eu/api/secure/oidc/authorize',
      scope: 'profile openid verified.national_id'
  }
};

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
